import { lazyLoad } from 'utils/loadable';
import { LoadingIndicator } from 'app/components/LoadingIndicator';

export const Home = lazyLoad(
  () => import('./index'),
  module => module.Home,
  {
    fallback: <LoadingIndicator />,
  },
);
